// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2W2ka","empty":"ModalGraph_empty__1OVCO"};